// extracted by mini-css-extract-plugin
export default {"span":"QuizSlider_span__bhzBf"};